export const ServicesJson = [
  {
    id: 1,
    title: 'DESENVOLVEDOR WEB',
    subtitle: 'Sites',
    desc: 'Atuo no desenvolvimento de sites performáticos e responsivos, com as melhores tecnologias do mercado',
    link: 'https://pt.wikipedia.org/wiki/Desenvolvimento_web'
  },
  {
    id: 2,
    title: 'DESENVOLVEDOR DE SOFTWARE',
    subtitle: 'Aplicações',
    desc: 'Desenvolvo aplicações performáticas, visando criar soluções para atender problemas de pequenas e médias empresas',
    link: 'https://pt.wikipedia.org/wiki/Desenvolvimento_de_software'
  },
  {
    id: 3,
    title: 'DESENVOLVEDOR WEB',
    subtitle: 'Landing pages',
    desc: 'Atuo no desenvolvimento de landing pages, visando colocar o seu negócio no universo digital!',
    link: 'https://pt.wikipedia.org/wiki/Landing_page'
  },
  {
    id: 4,
    title: 'DESENVOLVEDOR WEB',
    subtitle: 'Painéis administrativos',
    desc: 'Atuo no desenvolvimento de Painéis administrativos de variados estilos, de acordo com o que o cliente precisa.',
    link: ''
  },

]